export default "__VITE_ASSET__f5987920__"